<div class="account-activation-layout">
  <img alt="imagedetails" src="assets/images/login-registration/registration-logo.svg" class="logo" />
  <div class="account-activation-container">
    @if (isLoaded) {
      @if (isError) {
        <p class="error-message">{{ 'activate.account.page.error.message' | translate }}</p>
      } @else {
        @if (isEdit) {
          <fgbcl-registration-account-verification
            [emailAddress]="emailAddress"
            (onSubmit)="submit($event)"
            (onCancel)="isEdit = false; clearErrorMessages()"
            [isForm]="true"
          >
            @if (isFormError) {
              <div class="form-error-message">
                {{ 'activate.account.page.submit.error' | translate }}
              </div>
            }
          </fgbcl-registration-account-verification>
        } @else {
          <h5 class="account-activation-title">{{ 'account.activation.title' | translate }}</h5>

          <h6 class="account-activation-subtitle">{{ 'account.activation.subtitle' | translate }}</h6>
          <p
            class="account-activation-message"
            [innerHTML]="'account.activation.message' | translate: { email: emailAddress } | markdownTranslate"
          ></p>

          @if (isFormError) {
            <div class="form-error-message">
              {{ 'activate.account.page.submit.error' | translate }}
            </div>
          }
          <div class="account-resend-container">
            <p>{{ 'activate.account.page.no.email.received' | translate }}</p>
            <a href="#" (click)="$event.preventDefault(); resendEmail()">{{
              'activate.account.page.resend.email' | translate
            }}</a>
            <p>{{ 'activate.account.page.or' | translate }}</p>
            <a href="#" (click)="$event.preventDefault(); isEdit = true; clearErrorMessages()">{{
              'activate.account.page.different.email' | translate
            }}</a>
          </div>

          <div class="action-wrapper">
            <button class="submit-btn btn btn-success fw-bold" (click)="back()">
              {{ 'account.account.page.back.to.login.button' | translate }}
            </button>
          </div>
        }
      }
    } @else {
      <div class="loading-container">
        <fgbcl-loading [color]="'#333834'"></fgbcl-loading>
      </div>
    }
  </div>
</div>
